<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap" v-model="localVisible" :confirmLoading="loading" :maskClosable="false" @cancel="cancel" @ok="confirm">
      <div slot="title">{{ form.id ? "编辑" : "新增" }}</div>
        <div style="max-height: 65vh; overflow-y: auto;border: 1px solid #277fd0 ; overflow-x: hidden;padding: 10px;margin: -10px">
        <a-form-model ref="form" :model="form.others" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="name" label="名称">
            <a-input v-model="form.others.name" />
          </a-form-model-item>
          <a-form-model-item prop="number" label="编号">
            <a-input v-model="form.others.number" />
          </a-form-model-item>
          <a-form-model-item prop="license" label="车辆车牌">
            <a-input v-model="form.others.license" />
          </a-form-model-item>
          <a-form-model-item prop="loading_temperature" label="装货时温度">
            <a-input v-model="form.others.loading_temperature" />
          </a-form-model-item>
          <a-form-model-item prop="loading_time" label="装货时间">
            <a-date-picker style="width: 100%" :value="toMoment(form.others.loading_time)" @change="onChange" />
          </a-form-model-item>
          <a-form-model-item prop="midway_temperature" label="中途检测温度">
            <a-input v-model="form.others.midway_temperature" />
          </a-form-model-item>
          <a-form-model-item prop="test_time" label="检测时间">
            <a-input v-model="form.others.test_time" />
          </a-form-model-item>
          <a-form-model-item prop="unloading_temperature" label="卸货时温度">
            <a-input v-model="form.others.unloading_temperature" />
          </a-form-model-item>
          <a-form-model-item prop="unloading_time" label="卸货时间">
            <a-date-picker style="width: 100%" :value="toMoment(form.others.unloading_time)" @change="onChange1" />
          </a-form-model-item>
          <a-form-model-item prop="contact" label="联系人">
            <a-input v-model="form.others.contact" />
          </a-form-model-item>
          <a-form-model-item prop="phone" label="手机号">
            <a-input v-model="form.others.phone" />
          </a-form-model-item>
          <a-form-model-item prop="email" label="邮箱">
            <a-input v-model="form.others.email" />
          </a-form-model-item>
          <a-form-model-item prop="address" label="发货地址">
            <a-input v-model="form.others.address" />
          </a-form-model-item>
          <a-form-model-item prop="address1" label="到货地址">
            <a-input v-model="form.others.address1" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-input v-model="form.others.remark" allowClear />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { transportsAdd, transportsEdit } from "@/api/refrigerate";
import moment from "moment";

export default {
  name: "FormModal",
  props: ["visible", "form", "clientsClassificationOptions"],
  model: { prop: "visible", event: "cancel" },
  data() {
    return {
      levelOptions: [
        { id: "0", name: "0" },
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
      ],
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { max: 64, message: "超出最大长度 (64)", trigger: "blur" },
        ],
        number: [
          { required: true, message: "请输入编号", trigger: "blur" },
          { max: 32, message: "超出最大长度 (32)", trigger: "blur" },
        ]
      },
      loading: false,
      localVisible: this.visible,
    };
  },
  watch: {
    visible(v) { this.localVisible = v; },
  },
  methods: {
    onChange(date, dateString) {
      this.form.others.loading_time = dateString
    },
    onChange1(date, dateString) {
      this.form.others.unloading_time = dateString
    },
    toMoment(val) {
      return val ? moment(val) : null;
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let func = this.form.id ? transportsEdit : transportsAdd;
          func(this.form)
            .then(() => {
              this.$message.success(this.form.id ? "修改成功" : "新增成功");
              this.$emit(this.form.id ? "update" : "create");
              this.cancel();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
      if(!this.form.id) {
        this.$refs.form.resetFields();
      }
    },
  },
};
</script>

<style scoped></style>
